// Legend.js
// @flow
import * as React from 'react';
import helpers from '../util/helpers';
import safeUrl from '../util/safeUrl';
import { FormattedMessage } from 'react-intl';

type Props = {
	appState: Object,
	group: string
};

class Legend extends React.Component<Props> {

	constructor(props) {
		super(props)

		this.state={expanded: true}
	}

	toggleExpanded() {
		if (this.state.expanded) {
			helpers.eventLog(`legend - collapse legend`);
		} else {
			helpers.eventLog(`legend - expand legend`);
		}

		let newToggle = !this.state.expanded;
		this.setState({
			expanded: newToggle,
		})
	}

	render() {
		// console.log(this.props); //EPH
		let chemicalGroup = this.props.chemicalGroup;

		let houseORavatarPNG = helpers.houseORavatar(this.props.appState.avatar, this.props.group) + ".png";

		//console.log(houseORavatarPNG + "|" + this.props.group + "|"+ this.props.appState.avatar);

		let benchMarkIcon = helpers.benchmarkName(this.props.group); //XXX hardwired - better to glean this direct from the compounds.json data
		let benchMarkHTML = <tr></tr>;

		if (benchMarkIcon === "max_level")
		{
			benchMarkHTML =
				<tr>
				<td><svg height='20' width='20'>
				<image xlinkHref={safeUrl(`/images/graph-blue-star.png`)} width='12' height='12' transform='translate(7, 7)' />
				</svg>
				</td>
				<td><FormattedMessage id='graphs.max_level' defaultMessage='Nivel máximo de contaminante' /></td>
				</tr>;
		}

		if (benchMarkIcon === "us_median")
		{
			benchMarkHTML =
				<tr>
					<td><svg height='20' width='20'>
					<circle cx='13' cy='13' r='5' stroke='rgb(13 94 143)' fill='transparent' />
					<image xlinkHref={safeUrl(`/images/us.svg`)} width='8' height='8' transform='translate(9, 9)' />
					</svg>
					</td>
					<td><FormattedMessage id='graphs.us_median' defaultMessage='Media EEUU' /></td>
				</tr>;
		}

		let chevronState;
		if (this.state.expanded) {
			chevronState = "chevron-arrow-down"
		} else {
			chevronState = "chevron-arrow-right"
		}

		let circleRadius = 15;
		let rectWidth = circleRadius*2-10
		let rectHeight = rectWidth*0.7

		let avatarHTML;
		let avatarCircleHTML;
		if (this.props.appState.avatar == "face-7") {
			avatarCircleHTML = <circle cx={circleRadius} cy={circleRadius} r={circleRadius-1} stroke='white' strokeWidth="2px" fill='#ff5000' />
		} else {
			avatarHTML = <image xlinkHref={safeUrl(`/images/${houseORavatarPNG}`)} width={2*circleRadius} height={2*circleRadius}  />
			avatarCircleHTML = <circle cx={circleRadius} cy={circleRadius} r={circleRadius-1} stroke='#ff5000' strokeWidth="2px" fill='transparent' />
		}

		let iconRow;
		if (!this.state.expanded) {
			iconRow = (
				<div className="icon-row">
					<svg height={2*circleRadius} width={2*circleRadius}>
						{avatarHTML}
						{avatarCircleHTML}
					</svg>

					<svg height={2*circleRadius} width={2*circleRadius}>
						<line x1="0" y1={circleRadius} x2={2*circleRadius} y2={circleRadius} stroke="rgb(13 94 143)" strokeWidth="3px" />
						<image xlinkHref={safeUrl(`/images/usflag.svg`)} y={5} width={30} height={20}  />
						<rect x={circleRadius-rectWidth/2} y={circleRadius-rectHeight/2} width={rectWidth} height={rectHeight} rx={2} ry={2} stroke='rgb(13 94 143)' strokeWidth="2px" fill='transparent' />
					</svg>

					<svg height={2*circleRadius} width={2*circleRadius}>
						<circle cx={circleRadius} cy={circleRadius} r={circleRadius-4} stroke='rgb(119, 158, 255)' strokeWidth="3px" fill='transparent' />
					</svg>

					<svg height={2*circleRadius} width={2*circleRadius}>
						<circle cx={circleRadius} cy={circleRadius} r={circleRadius-4} stroke='#ccc' strokeWidth="3px" fill='transparent' />
					</svg>


				</div>
			)
		}

		let legendHeader = (
			<div className="legend-header" onClick={this.toggleExpanded.bind(this)}>
				<span className={chevronState+" legend-chevron"}></span>
				<h3 className="legend-header-text"><FormattedMessage id='graphs.legend' defaultMessage='Leyenda123' /></h3>
				{iconRow}
			</div>
		)


		let legendBody;
		if (this.state.expanded) {
			legendBody = (
					<div>
						<div className="legend-item">
							<div className="legend-icon" >
								<svg height={2*circleRadius} width={2*circleRadius}>
									{avatarHTML}
									{avatarCircleHTML}
								</svg>
							</div>
							<span className="legend-label"><FormattedMessage id='graphs.your_results' defaultMessage='Sus resultados' /></span>
						</div>

						<div className="legend-item">
							<div className="legend-icon" >
								<svg height={2*circleRadius} width={2*circleRadius}>
									<line x1="0" y1={circleRadius} x2={2*circleRadius} y2={circleRadius} stroke="rgb(13 94 143)" strokeWidth="5px" />
									<image xlinkHref={safeUrl(`/images/usflag.svg`)} y={5} width={30} height={20}  />
									<rect x={circleRadius-rectWidth/2} y={circleRadius-rectHeight/2} width={rectWidth} height={rectHeight} rx={2} ry={2} stroke='rgb(13 94 143)' strokeWidth="2px" fill='transparent' />
								</svg>
							</div>
							<span className="legend-label"><FormattedMessage id='graphs.us_median' defaultMessage='Media EEUU' /></span>
						</div>

						<div className="legend-item">
							<div className="legend-icon" >
								<svg height={2*circleRadius} width={2*circleRadius}>
									<circle cx={circleRadius} cy={circleRadius} r={circleRadius-4} stroke='rgb(119, 158, 255)' strokeWidth="3px" fill='transparent' />
								</svg>
							</div>
							<span className="legend-label"><FormattedMessage id='graphs.other_women' defaultMessage='Otras mujeres en PROTECT'  /></span>
						</div>

						<div className="legend-item">
							<div className="legend-icon" >
								<svg height={2*circleRadius} width={2*circleRadius}>
									<circle cx={circleRadius} cy={circleRadius} r={circleRadius-4} stroke='#ccc' strokeWidth="3px" fill='transparent' />
								</svg>
							</div>
							<span className="legend-label"><FormattedMessage id='graphs.non_detects' defaultMessage='Muestras donde no se detectó la sustancia química' /></span>
						</div>

						<div className="legend-item">
							<span className="legend-icon legend-unit"><FormattedMessage id={`chemicals.${chemicalGroup}.graph.units`} /></span>
							<span className="legend-label legend-unit-description"><FormattedMessage id={`chemicals.${chemicalGroup}.graph.units_description`} /></span>
						</div>

					</div>
			)
		}

		let theHTML2 = <div>
				<em><FormattedMessage id='graphs.legend' defaultMessage='Leyenda123' /></em><br/>
				<table>
					<tbody>

						{benchMarkHTML}

						<tr>
							<td valign='top'>
								<svg height='20' width='20'>
									<circle cx='13' cy='13' r='5' stroke='#ff5000' fill='transparent' />
									<image xlinkHref={safeUrl(`/images/${houseORavatarPNG}`)} width='10' height='10' transform='translate(8, 8)' />
								</svg>
							</td>
							<td><FormattedMessage id='graphs.your_results' defaultMessage='Sus resultados' /></td>
						</tr>

						<tr>
							<td valign='top'><svg height='20' width='20'><circle cx='13' cy='13' r='5' stroke='#097dc2' fill='transparent' /></svg></td>
							<td><FormattedMessage id='graphs.other_women' defaultMessage='Otras mujeres en PROTECT' /></td>
						</tr>

						<tr>
							<td valign='top'><svg height='20' width='20'><circle cx='13' cy='13' r='5' stroke='#ccc' fill='transparent' /></svg></td>
							<td><FormattedMessage id='graphs.non_detects' defaultMessage='Muestras donde no se detectó la sustancia química' /></td>
						</tr>
					</tbody>
				</table>
				<p className="printhide_v" id="id_clickformoreinfo"><FormattedMessage id='graphs.tap_to_learn' defaultMessage='Toque cualquier parte del gráfico para obtener más información' /></p>
			</div>;

		// return theHTML;
		return (
			<div>
				{legendHeader}
				{legendBody}
			</div>
		)
	}
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/Legend.js